import classNames from 'classnames';
import { Slider as _Slider, SliderMarkerLabels } from '../../../components';
import { LabelDisplay2 } from './LabelDisplay2';
import { LabelBody } from './LabelBody';
import { LabelBodyHeadline } from './index';

export type FeedbackText = {
    title: string;
    text: string;
};

type Props = {
    className?: string;
    title: string;
    description: string;
    value: number | null;
    setValue: (value: number) => void;
    feedbackTexts: { title: string; text: string } | null;
    backgroundImage?: string;
    min?: number;
    hideZeroLabel?: boolean;
};

export function Slider({
    className,
    title,
    description,
    value,
    setValue,
    feedbackTexts,
    backgroundImage,
    min = 1,
    hideZeroLabel = false,
}: Props) {
    const backgroundStyles = backgroundImage
        ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundPosition: 'top',
              backgroundRepeat: 'no-repeat',
              backgroundSize: value ? 'contain' : 'cover',
          }
        : {};

    return (
        <div
            style={backgroundStyles}
            className={classNames(
                className,
                'rounded-[20px] bg-dark-red-10p p-20',
            )}
        >
            <LabelDisplay2>{title}</LabelDisplay2>
            <LabelBody class="mb-20 mt-10">{description}</LabelBody>

            <SliderMarkerLabels
                min={min}
                max={4}
                hideZeroLabel={hideZeroLabel}
            />

            <_Slider
                min={min}
                max={4}
                value={value ?? min}
                onChangeValue={setValue}
            />

            {feedbackTexts && (
                <div className="flex flex-col items-center">
                    <LabelBodyHeadline className="mb-10 mt-20 text-center text-dark-red">
                        {feedbackTexts.title}
                    </LabelBodyHeadline>
                    <LabelBody className="text-center">
                        {feedbackTexts.text}
                    </LabelBody>
                </div>
            )}
        </div>
    );
}
